module.exports = __webpack_public_path__ + "media/images/google_pay-7bfeb229.svg";